import React, { useState, useEffect } from 'react';
import '../AccidentVehicle/AccidentVehicle.css';
import '../../../Component/CompanyAdmin/Location2/Location2.css';
import axios from 'axios' // '../../../axiosInstance';
import { useNavigate } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { Helmet } from 'react-helmet-async';
import DataTable from "react-data-table-component";
import Admin from '../AdminHome/SideBar/Admin';
import { Search, Download } from "lucide-react";
import { exportToExcel } from "../../../Services/exportToExcel";


const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const parseDate = (dateString) => {
  const [day, month, year] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day); // Months are 0-indexed in JavaScript
};


const ViewVehicleInfo = () => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  let [itemsPerPage, setItemsPerPage] = useState(10)
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");
  const [searchQuery, setSearchQuery] = useState('');
  const [width, setWidth] = useState('100%');


  const [isGenerated, setIsGenerated] = useState(false);
  const [generatedExcel, setGeneratedExcel] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [marginLeft, setMarginLeft] = useState('30px');
  const [paddingLeft, setPaddingLeft] = useState('30px');

  const [showMainContent, setShowMainContent] = useState(true)
  const [showEditVehicleInfo, setShowEditVehicleInfo] = useState(false)
  const [showUploadImage, setShowUploadImage] = useState(false)

  const [selectedId, setSelectedId] = useState(null);
  const [selectedUploadId, setSelectedUploadId] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);

  const handleRowsSelected = (state) => {
    setSelectedRows(state.selectedRows);
  }

  const conditionalRowStyles = [
    {
      when: (row) => selectedRows.some(selected => selected.accidentFileNo === row.accidentFileNo),
      style: {
        backgroundColor: '#bdb6b6',
      },
    }
  ];

  const tableCustomStyles = {
    headRow: {
      style: {
        color: '#ffff',
        backgroundColor: 'rgb(169 187 169)',
        fontWeight: "bold",
        fontSize: '13px'
      },
    },
    pagination: {
      style: {
        button: {
          background: 'none',
          boxShadow: "none"
        },
      },
    },
    striped: {
      style: {
        default: 'red'
      }
    },
    rows: {
      style: {
        backgroundColor: '#f2f2f2',
      }
    }
  }

  useEffect(() => {

    if (showMainContent) getData();

    if (token === "" || userId === "") {
      navigate("/");
    }
  }, [token, userId, navigate, showMainContent]);


  const generateFile = async () => {
    try {
      setIsLoading(true);
      console.log(userId)
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/registerDBToExcel/${userId}`, { headers: { Authorization: `Bearer ${token}` } });
      console.log("daa", response.data.data)
      console.log("response", response.data.data);
      setGeneratedExcel(response.data.data)
      setIsLoading(false);
      setIsGenerated(true);
    } catch (error) {
      setIsLoading(false);  // Ensure loading state is reset in case of error
      console.error(error.message);
    }
  }

  async function generateToken() {
    try {
      const authUrl = 'https://staging.eko.in:25004/ekoapi/v1/pan/verify';
      const authHeaders = {
        'Content-Type': 'application/x-www-form-urlencoded',
        "developer_key": "becbbce45f79c6f5109f848acd540567",
        "secret-key": "MC6dKW278tBef+AuqL/5rW2K3WgOegF0ZHLW/FriZQw=",
        "secret-key-timestamp": "1516705204593"
      };
      const authData = {
        "pan_number": "JTQPK6202L",
        "purpose": 1,
        "purpose_desc": "to know customer",
        "initiator_id": "9971771929",
        "developer_key": "becbbce45f79c6f5109f848acd540567",
        "secret-key": "MC6dKW278tBef+AuqL/5rW2K3WgOegF0ZHLW/FriZQw=",
        "secret-key-timestamp": "1516705204593"
      };
      console.log(authData);
      const authResponse = await axios.post(authUrl, authData, {
        headers: authHeaders,
      });
      console.log("some")
      console.log(authResponse.data);
      const token = authResponse.data.access_token;
      console.log('Access token', token);

      return token;
    } catch (error) {
      throw error.message;
    }
  }

  function view(id, AccidentVehicleCode, service) {
    console.log("myId", id)
    setSelectedId(id);
    setShowEditVehicleInfo(true)
    setShowMainContent(false)
    setShowUploadImage(false)
    // navigate("/vehicle-claim-edit", { state: { id } });
    navigate("/view-vehicle-journey-info", { state: { id, AccidentVehicleCode, service } });
  }

  const handleUpdate = () => {
    setShowEditVehicleInfo(false); // Hide VendorMasterEdit
    setShowMainContent(true)
    setShowUploadImage(false)
  };

  function upload(id) {
    console.log("myId", id)
    setSelectedUploadId(id);
    setShowEditVehicleInfo(false)
    setShowMainContent(false)
    setShowUploadImage(true)
    navigate("/daily-image-upload", { state: { id } });
  }

  const getData = async (e) => {

    const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/getWholeDetailsForAdmin`);
    const fetchedData = response.data.data;
    console.log('==============')
    console.log(fetchedData)

    const formattedData = fetchedData.map(item => ({
      ...item,
      systemDate: item.systemDate ? formatDate(item.systemDate) : "",

    }));
    console.log('flag')
    console.log(formattedData)
    setData(formattedData);
    setCurrentItems(formattedData);


  };

  const [currentItems, setCurrentItems] = useState(data);

  const columns = [

    { name: "ID", selector: (row) => row.id, sortable: true, width: '4rem' },
    { name: "Requested ID", selector: (row) => row.idForQuery, sortable: true, width: '12rem' },

    {
      name: "Customer Name", selector: (row) => row.CustomerName, sortable: true, width: '12rem',
      cell: (row) => (
        <span style={{ color: 'brown' }}>{row.CustomerName ? row.CustomerName.charAt(0).toUpperCase() + row.CustomerName.slice(1) : ""}</span>
      )
    },
    { name: "Phone No.", selector: (row) => row.CustomerPhone, sortable: true, width: '9rem' },
    { name: "Reg No. ", selector: (row) => row.reg, sortable: true, width: '8rem' },
    { name: "Type", selector: (row) => row.CustomerType, sortable: true, width: '6rem' },

    {
      name: "Order Status",
      width: '6rem',
      cell: (row) => {
        let status = "Pending";
        let color = "blue";

        if (row.cancelPreAssignOrderReason == 1) {
          status = "Pre Cancelled";
          color = "orange";
        } else if (row.completeOrder == 1 && row.closeOrder == 0) {
          status = "Completed";
          color = "green";
        } else if (row.completeOrder == 0 && row.closeOrder == 1) {
          status = "Cancelled";
          color = "red";
        }

        return <span style={{ color }}>{status}</span>;
      },
      sortable: true,
    },

    { name: "Cancel Reason", selector: (row) => row.cancelPreAssignOrderReason ? row.cancelPreAssignOrderReason : row.cancelOrderReason, sortable: true },


    { name: "Issue", selector: (row) => row.issue_occured, sortable: true },

    {
      name: "Actions",
      cell: (row) => (
        <button
          onClick={() => view(row.CustomerCode, row.AccidentVehicleCode, row.vendorType)}
          className='view-button'
        >
          View
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },

  ];

  const handleSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();

    const newRows = data.filter((row) => {
      const orderStatus = row.completeOrder === 1 && row.closeOrder === 0
        ? "completed"
        : row.completeOrder === 0 && row.closeOrder === 1
          ? "cancelled"
          : "pending";
      const idValue = (formatDate(row.id) ?? '').toLowerCase().includes(searchValue);
      const CustomerName = (row.CustomerName ?? '').toLowerCase().includes(searchValue);
      const cancelPreAssignOrderReason = (row.cancelPreAssignOrderReason ?? '').toLowerCase().includes(searchValue);
      const cancelOrderReason = (row.cancelOrderReason ?? '').toLowerCase().includes(searchValue);
      const reg = (row.reg ?? '').toLowerCase().includes(searchValue);
      const orderStatusValue = orderStatus.includes(searchValue);
      const reasonValue = (row.reason ?? '').toLowerCase().includes(searchValue);
      const vehicleNoValue = (row.vehicleNo ?? '').toLowerCase().includes(searchValue);
      const districtValue = (row.district ?? '').toLowerCase().includes(searchValue);
      const insuredByValue = (row.insuredBy ?? '').toLowerCase().includes(searchValue);

      return idValue || CustomerName || orderStatusValue || reg || cancelOrderReason || cancelPreAssignOrderReason || cancelOrderReason || reasonValue || vehicleNoValue || districtValue || insuredByValue;

    });

    setCurrentItems(newRows);
  };

  const [searchValue, setSearchValue] = useState('');

  const [filterType, setFilterType] = useState('completed');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const handleSubmit = async () => {
    console.log('handleSubmit calling: ')
    setIsGenerated(false);

    console.log({

      filter: filterType,
      from: fromDate,
      to: toDate
    })

    try {
      setIsLoading(true)
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/getWholeDetailsForAdmin`, {

        filter: filterType,
        from: fromDate,
        to: toDate
      });
      const fetchedData = response.data.data;
      console.log('==============')
      console.log(fetchedData)

      const formattedData = fetchedData.map(item => ({
        ...item,
        systemDate: item.systemDate ? formatDate(item.systemDate) : "",

      }));

      // console.log(formattedData)
      // setData(formattedData);
      setCurrentItems(formattedData);

    } catch (error) {
      console.log(error)
    }
    finally {
      setIsLoading(false)
    }


    return
    // 
    try {

      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/generate-excel`, {
        search: searchValue,
        filter: filterType,
        from: fromDate,
        to: toDate
      });

      if (response.data && response.data.fileUrl) {
        setGeneratedExcel(response.data.fileUrl);
        setIsGenerated(true);
      } else {
        alert('Excel file generation failed.');
      }
    } catch (error) {
      console.error('Error generating Excel:', error);
      alert('Something went wrong while generating the Excel file.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleExport = () => {
    // Export only selected rows if any, otherwise export all current items
    const exportData = selectedRows.length > 0 ? selectedRows : currentItems;
    // console.log(currentItems)
    exportToExcel(exportData, "Report");
  };

  return (
    <div style={{ marginTop: "-20px" }}>

      {isLoading && (
        <div className="fixed inset-0 z-[9999] bg-gray-100 bg-opacity-80 flex items-center justify-center">
          <div className="loader2 h-[50px] w-[20px]"></div>
        </div>
      )}

      <Admin />
      {showMainContent && (<div className="Customer-master-form font-satoshi" style={{ marginLeft: '10px', paddingLeft: '0px', marginRight: '10px', paddingRight: '0px' }}>
        <Helmet>
          <title>Accident Vehicle Infomation - Claimpro</title>
          <meta name="description" content="Accident Vehicle Infomation" />
          <meta name="keywords" content="Vehicle Accidents, accident trucks,  Customer Service, Claimpro, Claim pro Assist, Claimpro Assist ,Accidental repair ,Motor Insurance claim,Advocate services , Hydra Crane service ,On site repair,Accident Management" />
          <link rel='canonical' href={`https://claimpro.in/ViewVehicleInfo`} />
        </Helmet>

        <div style={{ marginTop: "-35px" }}>
          <h3 className="bigtitle ms-5 container">Accident Vehicle View / Edit</h3>

          <div className='container ms-5 mt-3' >
            <style>
              {`
                                                      .form-search {
                                                          display: flex;
                                                          flex-wrap: wrap;
                                                          gap: 10px;
                                                      }
          
                                                      @media (max-width: 768px) {
                                                          .form-search {
                                                          gap: 3px;
                                                          //   padding-right: 25px; /* ✅ Add spacing on right side */
                                                          margin-right: 25px; /* ✅ Add spacing on right side */
                                                          //   padding-left: -5px;  /* (Optional) to center more nicely */
                                                          }
          
                                                          .form-search > div {
                                                          flex: 1 1 100% !important;
                                                          min-width: 100% !important;
                                                          }
                                                      }
                                          `}
            </style>

            {/* below hidden div is unused, can be removed */}
            <div hidden className="form-search">
              {/* Search */}
              <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                <label className="label-class" style={{ width: '100%' }}>
                  Search by
                  <input
                    type="search"
                    className="form-control-sm border ps-3"
                    placeholder="Search"
                    // value={searchValue}
                    onChange={handleSearch}
                    style={{ width: '100%' }}
                  />
                </label>
              </div>

              {/* Filter Dropdown */}
              <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                <label className="label-class" style={{ width: '100%' }}>
                  Filter:
                  <select
                    className="form-control-sm border ps-2"
                    // value={filterType}
                    // onChange={e => setFilterType(e.target.value)}
                    style={{ width: '100%' }}
                  >
                    <option value="completed">Completed</option>
                    <option value="pre-canceled">Pre-canceled</option>
                    <option value="canceled">Canceled</option>
                  </select>
                </label>
              </div>

              {/* From Date */}
              <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                <label className="label-class" style={{ width: '100%' }}>
                  From:
                  <input
                    type="date"
                    className="form-control-sm border ps-2"
                    // value={fromDate}
                    // onChange={e => setFromDate(e.target.value)}
                    style={{ width: '100%' }}
                  />
                </label>
              </div>

              {/* To Date */}
              <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                <label className="label-class" style={{ width: '100%' }}>
                  To:
                  <input
                    type="date"
                    className="form-control-sm border ps-2"
                    // value={toDate}
                    // onChange={e => setToDate(e.target.value)}
                    style={{ width: '100%' }}
                  />
                </label>
              </div>

              {/* Generate/Download Excel Button */}
              <div style={{ flex: '1 1 200px', minWidth: '200px', marginTop: "10px" }}
              // onClick={handleSubmit}
              // onMouseEnter={() => setIsHovered(true)}
              // onMouseLeave={() => setIsHovered(false)}
              >
                <label className="label-class" style={{ width: '100%', display: 'block' }}>
                  &nbsp; {/* Placeholder to align */}

                  <a
                    // href={generatedExcel}
                    onClick={handleSubmit}
                    className="form-control download-link"
                    style={{ textAlign: 'center' }}
                  >
                    Search
                  </a>

                </label>
              </div>
            </div>

            <div >
              {/* Embedded CSS for responsiveness */}
              <style>
                {`
              .form-search {
                display: flex;
                flex-wrap: wrap;
                gap: 10px;
              }
            
              @media (max-width: 768px) {
                .form-search {
                  gap: 3px;
                //   padding-right: 25px; /* ✅ Add spacing on right side */
                  margin-right: 25px; /* ✅ Add spacing on right side */
                //   padding-left: -5px;  /* (Optional) to center more nicely */
                }
            
                .form-search > div {
                  flex: 1 1 100% !important;
                  min-width: 100% !important;
                }
              }
            `}
              </style>


              {/* <h3 className="bigtitle">Sign-up Vendor</h3> */}

              <div className="form-search flex">

                {/* Search */}
                <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                  <label className="label-class" style={{ width: '100%' }}>
                    Search by
                    <input
                      type="search"
                      className="form-control-sm border ps-3"
                      placeholder="Search"
                      // value={searchValue}
                      onChange={handleSearch}
                      style={{ width: '100%' }}
                    />
                  </label>
                </div>

                {/* Filter Dropdown */}
                <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                  <label className="label-class" style={{ width: '100%' }}>
                    Filter:
                    <select
                      className="form-control-sm border ps-2"
                      value={filterType}
                      onChange={e => setFilterType(e.target.value)}
                      style={{ width: '100%' }}
                    >
                      <option value="completed">Completed</option>
                      <option value="pre-cancelled">Pre-cancelled</option>
                      <option value="post-cancelled">Cancelled</option>
                    </select>
                  </label>
                </div>

                {/* From Date */}
                <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                  <label className="label-class" style={{ width: '100%' }}>
                    From:
                    <input
                      type="date"
                      className="form-control-sm border ps-2"
                      value={fromDate}
                      onChange={e => setFromDate(e.target.value)}
                      style={{ width: '100%' }}
                    />
                  </label>
                </div>

                {/* To Date */}
                <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                  <label className="label-class" style={{ width: '100%' }}>
                    To:
                    <input
                      type="date"
                      className="form-control-sm border ps-2"
                      value={toDate}
                      onChange={e => setToDate(e.target.value)}
                      style={{ width: '100%' }}
                    />
                  </label>
                </div>

                {/* Buttons */}
                <div className='flex  gap-2 '>

                  {/* <Search
                    className="w-6 h-6 text-gray-600 cursor-pointer transition-transform transform hover:scale-125 hover:text-gray-600"
                  />

                  <Download
                    className="w-6 h-6 text-gray-600 cursor-pointer transition-transform transform hover:scale-125 hover:text-blue-600"
                  /> */}

                  <button onClick={handleSubmit}>
                    <Search className="w-6 h-6 text-gray-600" />
                  </button>
                  <button onClick={handleExport}>
                    <Download className="w-6 h-6 text-gray-600" />
                  </button>
                </div>

              </div>

            </div>

          </div>

        </div>

        <div className="container d-flex justify-content-center " >
          <div className="container-for-tables my-4">
            <DataTable
              columns={columns}
              data={currentItems}
              fixedHeader
              pagination
              selectableRows
              onSelectedRowsChange={handleRowsSelected}
              conditionalRowStyles={conditionalRowStyles}
              customStyles={tableCustomStyles}
            />

            {/* <DataTable
              columns={columns}
              data={currentItems}
              fixedHeader
              pagination
              selectableRows
              onSelectedRowsChange={handleRowsSelected}
            /> */}

          </div>
        </div>

      </div>)}
      {/* {showEditVehicleInfo && (
        <VehicleClaimEdit id={selectedId} onUpdate={handleUpdate} />
      )} */}
      {/* {showUploadImage && (
        <ImageUpload id={selectedUploadId} onUpdate={handleUpdate} />
      )} */}
    </div>
  );

};

export default ViewVehicleInfo;
